export default __webpack_public_path__ + "3451bb04d44f025686f1a255e087b18d.svg";